const KEY = "brickstok_kyc_status";

export const isKycCompleted = () => {
  try {
    return localStorage.getItem(KEY) === "completed";
  } catch {
    return false;
  }
};

export const markKycCompleted = () => {
  try {
    localStorage.setItem(KEY, "completed");
  } catch {
    /* ignore */
  }
};

export const resetKyc = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
};
